module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-container"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "type-wrap"
  }, [_c('router-link', {
    staticClass: "home-page",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页>")]), _vm._v(" "), _c('span', {
    staticClass: "type-name"
  }, [_vm._v("关于我们")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page__title"
  }, [_c('h2', {
    staticClass: "large__title"
  }, [_vm._v(_vm._s(_vm.aboutUs[0]))]), _vm._v(" "), _c('h4', {
    staticClass: "small__title square"
  }, [_vm._v(_vm._s(_vm.aboutUs[1]))])]), _vm._v(" "), _c('div', {
    staticClass: "about-introduction"
  }, [_c('div', {
    staticClass: "text-indent",
    domProps: {
      "innerHTML": _vm._s(_vm.itemList[0].content)
    }
  })]), _vm._v(" "), _vm._l((_vm.itemList), function(item, index) {
    return (index > 0) ? _c('div', {
      staticClass: "paragraph-wrapper"
    }, [_c('div', {
      staticClass: "item"
    }, [_c('h4', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "row row-indent",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _vm._m(0)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-caption"
  }, [_c('div', {
    staticClass: "point"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4656b388"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/company.vue
// module id = 599
// module chunks = 1